var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartFlatbedEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M616 399.996H144V64C144 28.799 115.199 0 80 0H24C10.801 0 0 10.801 0 24C0 37.201 10.801 48 24 48H72C85.254 48 96 58.744 96 72V415.996C96 433.596 110.4 447.996 128 447.996H162.939C161.15 453.025 160 458.357 160 464C160 490.51 181.49 512 208 512S256 490.51 256 464C256 458.357 254.85 453.025 253.061 447.996H450.939C449.15 453.025 448 458.357 448 464C448 490.51 469.49 512 496 512S544 490.51 544 464C544 458.357 542.85 453.025 541.061 447.996H616C629.199 447.996 640 437.197 640 423.996C640 410.797 629.199 399.996 616 399.996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartFlatbedEmpty);
export default __webpack_public_path__ + "static/media/cart-flatbed-empty.3564fe93d273122f9bfc9f21bda72dd0.svg";
export { ForwardRef as ReactComponent };